export var Platform = /*#__PURE__*/function (Platform) {
  Platform["ANDROID"] = "android";
  Platform["IOS"] = "ios";
  Platform["PC"] = "pc";
  return Platform;
}({});
export var isMobilePlatform = function isMobilePlatform() {
  return getPlatform() !== Platform.PC;
};
export var getPlatform = function getPlatform() {
  // navigator is browser-only, this line lets the backend render without crashing
  var navigator = globalThis.navigator || {
    userAgent: ''
  };
  var userAgent = navigator.userAgent;
  var isAndroid = /Android/i.test(userAgent);
  if (isAndroid) {
    return Platform.ANDROID;
  }
  var isIOS = /(iPhone|iPad)/i.test(userAgent);
  if (isIOS) {
    return Platform.IOS;
  }
  return Platform.PC;
};